import React, {memo} from "react";
import PropTypes from "prop-types";
import {Chip} from "@mui/material";
import {useChipStyles} from "./chipStyles";
import {isString} from "underscore";

const StyledChip = memo(({
  data,
  defaultLabel,
  labelKey,
  size = "small",
  margin,
  clickable,
  fullWidth,
}) => {
  let label = data && data[labelKey || "name"];
  if (!data || !label) {
    if (isString(defaultLabel)) {
      label = defaultLabel;
    } else {
      return null;
    }
  }
  const {classes} = useChipStyles({
    background: data?.backgroundColor,
    foreground: data?.foregroundColor,
    margin: margin ?? 0,
    clickable,
    fullWidth,
  });
  return <Chip label={label} size={size} className={classes.styledChip} />;
});

StyledChip.displayName = "StyledChip";

StyledChip.propTypes = {
  data: PropTypes.object,
  defaultLabel: PropTypes.string,
  labelKey: PropTypes.string,
  size: PropTypes.string,
  margin: PropTypes.string,
  clickable: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default StyledChip;
